import { render, staticRenderFns } from "./CadastrarAnexo.vue?vue&type=template&id=6c98c600&scoped=true"
import script from "./CadastrarAnexo.vue?vue&type=script&lang=js"
export * from "./CadastrarAnexo.vue?vue&type=script&lang=js"
import style0 from "./CadastrarAnexo.vue?vue&type=style&index=0&id=6c98c600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c98c600",
  null
  
)

export default component.exports